module.exports = __webpack_public_path__ + "static/img/three_icon_2.99c1fe43.png";